import React from "react";
import StackedBarChart from "../../components/sharedComponets/StackedBarChart/index.js";
import StackedAreaChart from "../../components/sharedComponets/StackedAreaChart/index.js";
import EmptyStates from "../../components/sharedComponets/EmptyStates/index.js";
import StackedAreaChartAction from "../../components/sharedComponets/StackedAreaChart/action/StackedAreaChartAction.js";
import StackedAreaChartCopyAction from "../../components/sharedComponets/StackedAreaChartCopy/action/StackedAreaChartAction.js";
import ActionsTypeCountAction from "../Dashboard/action/ActionsTypeCountAction.js";
import ActionsTypeCountStore from "../Dashboard/store/ActionsTypeCountStore.js";
import QueriesTypeCountAction from "../Dashboard/action/QueriesTypeCountAction.js";
import QueriesTypeCountStore from "../Dashboard/store/QueriesTypeCountStore.js";
import ViewsTypeCountAction from "../Dashboard/action/ViewsTypeCountAction.js";
import ViewsTypeCountStore from "../Dashboard/store/ViewsTypeCountStore.js";
import GetHistogramAction from "../Dashboard/action/GetReviewHistogramAction.js";
import GetHistogramStore from "../Dashboard/store/GetHistogramStore.js";



import GetSuggestionsAction from "../Dashboard/action/GetSuggestionAction.js";

import GetLocationsStatesAction from "../Dashboard/action/GetLocationStatesAction.js";
import GetLocationsStatesStore from "../Dashboard/store/GetLocationStateStore.js";
import GetLocationInsightAction from "../Dashboard/action/GetLocationInsightAction.js";
import GetLocationInsightStore from "../Dashboard/store/GetLocationInsightStore.js";
import StackedBarChartAction from "../../components/sharedComponets/StackedBarChart/action/StackedBarChartAction.js";
import LoadingStatusStore from "../Dashboard/store/LoadingStatusStore.js";
import GetProfilesStore from "../AuthorisePage/store/GetProfilesStore.js";
import ChangeProfileStore from "../Dashboard/store/ChangeProfileStore.js";
import GetDataStatusAction from "../Dashboard/action/GetDataStatusAction.js";
import GetDataStatusStore from "../Dashboard/store/GetDataStatusStore.js";
import GetDataFetchStatusStore from "../Dashboard/store/GetDataFetchStatusStore.js";

import InsightGroupBarchartAction from "../../components/sharedComponets/InsightsGroupBarChart/action/BarchartAction.js";
import PhotosTypeCountAction from "../Dashboard/action/PhotosTypeCountAction.js";
import PhotosTypeCountStore from "../Dashboard/store/PhotosTypeCountStore.js";
import PhotosTypeCountCustomerStore from "../Dashboard/store/PhotosTypeCountCustomerStore.js";

import LocalHistogramAction from "../../components/sharedComponets/LocalHistogramComponent/action/LocalHistogramAction.js";
import DatewiseInsightHistoAction from "../Dashboard/action/DatewiseInsightHistoAction.js";
import DatewiseInsightHistoStore from "../Dashboard/store/DatewiseInsightHistoStore.js";
import "../../../public/css/print.css";
import "../DownloadPage/style.scss";
import MetricCard from "../../components/MetricCard1/index.js";
import {
	METRIC_CARD_CONSTANTS,
	TOOLTIP_CONSTANTS,
} from "../LPOTab/PerformancePageConstants.js";
import styles from "./styles.module.scss";
import {
	findLabelValue,
	findPercent,
	modifyPieChartData,
} from "../LPOTab/children/Overview/helpers.js";
import LPOChartWrapper from "../../components/LPOChartWrapper1/index.js";
import { ComposedBarChart } from "../../components/sharedComponets/ComposedChart/index.js";
import CommentsGraphWrapper from "../../components/CommentGraphsWrapper1/index.js";
import GetPerformanceOverviewStore from "../LPOTab/store/GetPerformanceOverviewStore.js";
import GetPerformanceOverviewAction from "../LPOTab/action/GetPerformanceOverviewAction.js";
import { urlName } from "../../config/index.js";
import GetStackedAreaChartStore from "../LPOTab/store/StackedAreaChartStore.js";
import GetStackedAreaChartAction from "../LPOTab/action/StackedAreaChartAction.js";
import GetLocationInsightMetricCountStore from "../LPOTab/store/GetLocationInsightMetricCountStore.js";
import GetLocationInsightMetricCountAction from "../LPOTab/action/GetLocationInsightMetricCountAction.js";
import DateWiseHistoStore from "../LPOTab/store/DateWiseHistoStore.js";
import DateWiseHistoAction from "../LPOTab/action/DateWiseHistoAction.js";
import GetActionsTypeCountStore from "../LPOTab/store/GetActionsTypeCountStore.js";
import GetActionsTypeCountAction from "../LPOTab/action/GetActionsTypeCountAction.js";
import LineChartStore from "../LPOTab/store/LineChartStore.js";
import LineChartAction from "../LPOTab/action/LineChartAction.js";
import LineChartComponent from "../../components/sharedComponets/LineComponentChart/index.js";
import LocalHistogramStore from "../LPOTab/store/LocalHistogramStore.js";
import LocalHistogemAction from "../LPOTab/action/LocalHistogemAction.js";
import LocalHistogramComponent from "../../components/sharedComponets/LocalHistogramComponentChart/index.js";
import GetDomainDetailsStore from "../../flux/dispatcher/store/GetDomainDetailsStore.js";
var Spinner = require("react-spinkit");
var config = require("../../../globalconfig.js");
var cookie = require("../../utils/cookie.js");
var _ = require("lodash");
var moment = require("moment");
var languageFile = require("../../../public/languages/Translation.js");

var intervalFunction;
const fieldsMap = {
	country: "Country",
	area: "State",
	locality: "Administrative area",
	starType: "Star rating",
	starValue: "",
	organizations: "Account name",
	gt: "Greater than",
	lt: "Less than",
	equals: "Equals",
	GT: "Greater than",
	LT: "Less than",
	EQUALS: "Equals",
	reviewCategory: "Review Category",
	locationFilterName: "Group",
	locationName: "locationName",
	// jobType: "Report",
};
const tagStyles = {
	country: {
		color: "#eb2f96",
		background: "#fff0f6",
		borderColor: "#ffadd2",
	},
	area: {
		color: "#722ed1",
		background: "#f9f0ff",
		borderColor: "#d3adf7",
	},
	locality: {
		color: "#faad14",
		background: "#fffbe6",
		borderColor: "#ffe58f",
	},
	starType: {
		color: "#d46b08",
		background: "#fff7e6",
		borderColor: "#ffd591",
	},
	organizations: {
		color: "#52c41a",
		background: "#f6ffed",
		borderColor: "#b7eb8f",
	},
	reviewCategory: {
		color: "#095454",
		background: "#e6fffb",
		borderColor: "#87e8de",
	},
	locationFilterName: {
		color: "#531dab",
		background: "#f9f0ff",
		borderColor: "#d3adf7",
	},
	locationName: {
		color: "#0050b3",
		background: "#e6f7ff",
		borderColor: "#69c0ff",
	},
};
class DownloadPerformanceInsights extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			pieChartLoading: true,
			publishedLocations: 0,
			verifiedLocations: 0,
			openInfo: {},
			queriesPiedata: {},
			actionsPieData: {},
			viewsPiedata: {},
			viewsLoading: true,
			queriesLoading: true,
			actionsLoading: true,
			searchesCount: 0,
			viewsCount: 0,
			master: false,
			locationId: [],
			metricData: [],
			localHistoData: [],
			localHistoMetric: [],
			customerViewData: [],
			dateWiseHistoData: [],
			customerActionData: [],
			actionsPieData: {},
			country: "",
			locality: "",
			locationName: "",
			administrativeArea: "",
			city: "",
			currentGranularity: { value: "weekly", label: "Weekly" },
			actionsCount: 0,
			dateRange: {
				fromDate: moment().subtract(16, "week").format("YYYY-MM-DD"),
				toDate: moment().format("YYYY-MM-DD"),
			},
			date: {
				from: moment().subtract(16, "week").format("YYYY-MM-DD"),
				to: moment().format("YYYY-MM-DD"),
			},
		};
		this.parseUrl = this.parseUrl.bind(this);
		this.LocalHistogram = this.LocalHistogram.bind(this);
		this.onDatewiseActionCount = this.onDatewiseActionCount.bind(this);
		this.onFetchStatus = this.onFetchStatus.bind(this);
		this.onStatusResponse = this.onStatusResponse.bind(this);
		this.onProfileChange = this.onProfileChange.bind(this);
		this.onLoadChange = this.onLoadChange.bind(this);
		this.onPhotosCountResponse = this.onPhotosCountResponse.bind(this);
		this.onPhotosCountResponseCustomer =
			this.onPhotosCountResponseCustomer.bind(this);
		this.onActionsCountResponse = this.onActionsCountResponse.bind(this);
		this.onViewsCountResponse = this.onViewsCountResponse.bind(this);
		this.onQueriesCountResponse = this.onQueriesCountResponse.bind(this);
		this.onInsightsResponse = this.onInsightsResponse.bind(this);
		this.onLocationStates = this.onLocationStates.bind(this);
		this.onGraphResponse = this.onGraphResponse.bind(this);
		this.generateReportFilters = this.generateReportFilters.bind(this);
		this.generateReportHeader = this.generateReportHeader.bind(this);
		this.getData = this.getData.bind(this);
		this.ChangeFormateDate = this.ChangeFormateDate.bind(this);
		this.ChangeDivider = this.ChangeDivider.bind(this);
	}

	componentWillMount() {
		GetDataStatusStore.bind(this.onStatusResponse);
		GetHistogramStore.bind(this.onGraphResponse);
		GetLocationsStatesStore.bind(this.onLocationStates);
		GetLocationInsightStore.bind(this.onInsightsResponse);
		ActionsTypeCountStore.bind(this.onActionsCountResponse);
		ViewsTypeCountStore.bind(this.onViewsCountResponse);
		PhotosTypeCountStore.bind(this.onPhotosCountResponse);
		PhotosTypeCountCustomerStore.bind(this.onPhotosCountResponseCustomer);
		QueriesTypeCountStore.bind(this.onQueriesCountResponse);
		LoadingStatusStore.bind(this.onLoadChange);
		GetProfilesStore.bind(this.onProfilesResponse);
		ChangeProfileStore.bind(this.onProfileChange);
		GetDataFetchStatusStore.bind(this.onFetchStatus);
		LocalHistogramStore.bind(this.getLocalHistogram);
		GetPerformanceOverviewStore.bind(this.getPerformanceOverview);

		DatewiseInsightHistoStore.bind(this.onDatewiseActionCount);
		GetStackedAreaChartStore.bind(this.getStackedAreaData);
		GetLocationInsightMetricCountStore.bind(this.getLocationInsight);
		DateWiseHistoStore.bind(this.getDateWiseHisto);
		GetActionsTypeCountStore.bind(this.getActionType);
		LineChartStore.bind(this.getLineChartData);

		this.jobType = null;
	}
	parseUrl(queryParams) {
		var filtersObject = {};
		var fields = queryParams.split("&");
		for (var i in fields) {
			if (fields[i].split("=")[1]) {
				if (fields[i].split("=")[0] == "jobType") {
					this.jobType = decodeURIComponent(fields[i].split("=")[1]);
				}
				if (
					fields[i].split("=")[0] == "fromDate" ||
					fields[i].split("=")[0] == "toDate"
				) {
					if (!filtersObject.hasOwnProperty("reviewFilters")) {
						filtersObject.reviewFilters = {};
						filtersObject.reviewFilters.dateRange = {};
						filtersObject.reviewFilters.date = {};
					}
					if (fields[i].split("=")[0] == "fromDate") {
						filtersObject.reviewFilters.dateRange.from = decodeURIComponent(
							fields[i].split("=")[1],
						);
						filtersObject.reviewFilters.date.from = decodeURIComponent(
							fields[i].split("=")[1],
						);
					}
					if (fields[i].split("=")[0] == "toDate") {
						filtersObject.reviewFilters.dateRange.to = decodeURIComponent(
							fields[i].split("=")[1],
						);
						filtersObject.reviewFilters.date.to = decodeURIComponent(
							fields[i].split("=")[1],
						);
					}
				}
				if (
					fields[i].split("=")[0] == "starType" ||
					fields[i].split("=")[0] == "starValue"
				) {
					if (!filtersObject.hasOwnProperty("reviewFilters")) {
						filtersObject.reviewFilters = {};
					} else if (
						!filtersObject.reviewFilters.hasOwnProperty("starRatingFilter")
					) {
						filtersObject.reviewFilters.starRatingFilter = {};
					}
					if (fields[i].split("=")[0] == "starType") {
						filtersObject.reviewFilters.starRatingFilter["type"] =
							decodeURIComponent(fields[i].split("=")[1]);
					}
					if (fields[i].split("=")[0] == "starValue") {
						filtersObject.reviewFilters.starRatingFilter["value"] =
							decodeURIComponent(fields[i].split("=")[1]);
					}
				}
				//adding reviewCategory to the request body
				//by Liju Kuriakose
				if (fields[i].split("=")[0] == "reviewCategory") {
					if (!filtersObject.hasOwnProperty("reviewFilters")) {
						filtersObject.reviewFilters = {};
					}
					if (fields[i].split("=")[0] == "reviewCategory") {
						filtersObject.reviewFilters.reviewCategory = decodeURIComponent(
							fields[i].split("=")[1],
						);
					}
				}
				if (fields[i].split("=")[0] == "locationFilterId") {
					filtersObject["locationFilterId"] = decodeURIComponent(
						fields[i].split("=")[1],
					);
				}
				//
				if (
					fields[i].split("=")[0] == "country" ||
					fields[i].split("=")[0] == "area" ||
					fields[i].split("=")[0] == "locality" ||
					fields[i].split("=")[0] == "locationName" ||
					fields[i].split("=")[0] == "administrativeArea" ||
					fields[i].split("=")[0] == "city"
				) {
					if (!filtersObject.hasOwnProperty("locationFilters")) {
						filtersObject.locationFilters = {};
					}
				}
				if (fields[i].split("=")[0] == "country") {
					filtersObject.locationFilters.country = decodeURIComponent(
						fields[i].split("=")[1],
					);
					this.setState({
						country: filtersObject.locationFilters.country,
						locationId: [],
					});
				}
				if (fields[i].split("=")[0] == "administrativeArea") {
					filtersObject.locationFilters.administrativeArea = decodeURIComponent(
						fields[i].split("=")[1],
					);
					this.setState({
						administrativeArea:
							filtersObject.locationFilters.administrativeArea,
						locationId: [],

					});
				}
				if (fields[i].split("=")[0] == "city") {
					filtersObject.locationFilters.city = decodeURIComponent(
						fields[i].split("=")[1],
					);
					this.setState({
						city: filtersObject.locationFilters.city,
						locationId: [],

					});
				}
				if (fields[i].split("=")[0] == "area") {
					filtersObject.locationFilters.area = decodeURIComponent(
						fields[i].split("=")[1],
					);
					this.setState({
						administrativeArea: filtersObject.locationFilters.area,
						locationId: [],

					});
				}
				if (fields[i].split("=")[0] == "locality") {
					filtersObject.locationFilters.locality = decodeURIComponent(
						fields[i].split("=")[1],
					);
					this.setState({
						locality: filtersObject.locationFilters.locality,
						city: filtersObject.locationFilters.locality,
						locationId: [],
					});
				}
				if (fields[i].split("=")[0] == "locationName") {
					filtersObject.locationFilters.locationName = decodeURIComponent(
						fields[i].split("=")[1],
					);
					this.setState({
						locationId: [],
						locationName: filtersObject.locationFilters.locationName,
					});
				}
				if (fields[i].split("=")[0] == "masterLocationFilter") {
					filtersObject.masterLocationFilter = decodeURIComponent(
						fields[i].split("=")[1],
					);
					this.setState({
						master: filtersObject.masterLocationFilter,
					});
				}
				if (fields[i].split("=")[0] == "searchText") {
					filtersObject.reviewFilters.searchText = decodeURIComponent(
						fields[i].split("=")[1],
					);
				}
				filtersObject[fields[i].split("=")[0]] = decodeURIComponent(
					fields[i].split("=")[1],
				);
				//by Liju Kuriakose
				if (fields[i].split("=")[0] == "organizations") {
					filtersObject.organizations = [
						decodeURIComponent(fields[i].split("=")[1]),
					];
				}
				if (fields[i].split("=")[0] == "sources") {
					let sorceList = decodeURIComponent(fields[i].split("=")[1]);
					filtersObject.sources = sorceList.split(",").map((item) => {
						return item.replace("[", "").replace("]", "");
					});
				}
			}
		}
		filtersObject.dateRange = {
			from: filtersObject.fromDate,
			to: filtersObject.toDate,
		};
		this.setState({
			date: { from: filtersObject.fromDate, to: filtersObject.toDate },
		});
		cookie.createCookie("lctoken", filtersObject.token, 2);
		localStorage.setItem("profileId", filtersObject.profileId);
		localStorage.setItem(
			"masterLocationFilter",
			filtersObject.masterLocationFilter,
		);
		localStorage.setItem("filters", filtersObject);
		delete filtersObject["token"];
		if (filtersObject.language == "portuguese") {
			moment.locale("pt");
		} else if (filtersObject.language == "english") {
			moment.locale("en");
		} else if (filtersObject.language == "german") {
			moment.locale("de");
		} else if (filtersObject.language == "spanish") {
			moment.locale("es");
		} else if (filtersObject.language == "french") {
			moment.locale("fr");
		} else if (filtersObject.language == "日本語") {
			moment.locale("ja");
		}
		return filtersObject;
	}
	componentDidMount() {
		var filters = this.parseUrl(this.props.match.params.query);

		StackedAreaChartAction.addDownloadFilters(filters);
		StackedAreaChartCopyAction.addDownloadFilters(filters);
		InsightGroupBarchartAction.addDownloadFilters(filters);
		ActionsTypeCountAction.addDownloadFilters(filters);
		QueriesTypeCountAction.addDownloadFilters(filters);
		ViewsTypeCountAction.addDownloadFilters(filters);
		PhotosTypeCountAction.addDownloadFilters(filters);
		GetLocationsStatesAction.addDownloadFilters(filters);
		StackedBarChartAction.addDownloadFilters(filters);
		GetHistogramAction.addDownloadFilters(filters);
		DatewiseInsightHistoAction.addDownloadFilters(filters);
		GetLocationInsightAction.addDownloadFilters(filters);
		GetPerformanceOverviewAction.getPerformanceOverview({
			profileId: localStorage.getItem("profileId"),
			masterLocationFilter: localStorage.getItem("masterLocationFilter"),
			filters: { ...filters },
			domainName: urlName,
		});
		GetLocationInsightMetricCountAction.getData({
			filters: { ...filters },
			profileId: localStorage.getItem("profileId"),
		});
		GetStackedAreaChartAction.loadData({
			profileId: localStorage.getItem("profileId"),
			sources: filters.sources ? filters.sources : [],
			filters: { ...filters },
			domainName: urlName,
			granularity: "daily",
		});
		DateWiseHistoAction.loadData({
			profileId: localStorage.getItem("profileId"),
			sources: [],
			filters: { ...filters },
		});

		GetActionsTypeCountAction.getData({
			filters: { ...filters },
			profileId: localStorage.getItem("profileId"),
		});

		LineChartAction.loadData({
			profileId: localStorage.getItem("profileId"),
			sources: filters.sources ? filters.sources : [],
			filters: { ...filters },
			domainName: urlName,
			granularity: "daily",
		});
		LocalHistogemAction.loadData({
			profileId: localStorage.getItem("profileId"),
			sources: filters.sources ? filters.sources : [],
			filters: { ...filters },
			// filters:{dateRange:props.dateRange},
			domainName: urlName,
			granularity: "daily",
		});
	}
	componentWillUnmount() {
		GetDataStatusStore.unbind(this.onStatusResponse);
		GetHistogramStore.unbind(this.onGraphResponse);
		GetLocationsStatesStore.unbind(this.onLocationStates);
		GetLocationInsightStore.unbind(this.onInsightsResponse);
		ActionsTypeCountStore.unbind(this.onActionsCountResponse);
		ViewsTypeCountStore.unbind(this.onViewsCountResponse);
		QueriesTypeCountStore.unbind(this.onQueriesCountResponse);
		LoadingStatusStore.unbind(this.onLoadChange);
		PhotosTypeCountStore.unbind(this.onPhotosCountResponse);
		PhotosTypeCountCustomerStore.unbind(this.onPhotosCountResponseCustomer);
		GetProfilesStore.unbind(this.onProfilesResponse);
		ChangeProfileStore.unbind(this.onProfileChange);
		GetHistogramAction.clearFilters();
		DatewiseInsightHistoAction.clearFilters();
		GetDataFetchStatusStore.unbind(this.onFetchStatus);
		DatewiseInsightHistoStore.unbind(this.onDatewiseActionCount);
		InsightGroupBarchartAction.clearFilters();
		GetPerformanceOverviewStore.unbind(this.getPerformanceOverview);
		GetStackedAreaChartStore.unbind(this.getStackedAreaData);
		GetLocationInsightMetricCountStore.unbind(this.getLocationInsight);
		DateWiseHistoStore.unbind(this.getDateWiseHisto);
		GetActionsTypeCountStore.unbind(this.getActionType);
		LineChartStore.unbind(this.getLineChartData);
		LocalHistogramStore.unbind(this.getLocalHistogram);

		clearInterval(intervalFunction);
	}
	
	getLocalHistogram = () => {
		let response = LocalHistogramStore.getResponse();
		if (response.status == 200) {
			let response = LocalHistogramStore.getResponse();
			this.setState({
				localHistoData: response.histogram,
				localHistoMetric: response.metricCount,
			});
		} else {
			this.setState({ localHistoData: [], localHistoMetric: [] });
		}
	};
	getLineChartData = () => {
		let response = LineChartStore.getResponse();
		if (response.status == 200) {
			this.setState({ customerActionData: response.histogram });
		} else {
			this.setState({ customerActionData: [] });
		}
	};
	getActionType = () => {
		let response = GetActionsTypeCountStore.getResponse();
		var hashMap = {
			ACTIONS_DRIVING_DIRECTIONS: "Driving Directions",
			ACTIONS_PHONE: "Phone",
			ACTIONS_WEBSITE: "Website",
			date: "date",
		};

		var data = modifyPieChartData(response, hashMap);
		if (data) {
			this.setState({ actionsPieData: data });
		} else {
			this.setState({ actionsPieData: {} });
		}
	};
	getDateWiseHisto = () => {
		let response = DateWiseHistoStore.getResponse();
		if (response.status == 200) {
			let hashMap = {
				ACTIONS_DRIVING_DIRECTIONS:
					languageFile[localStorage.getItem("language")]["10792"],
				ACTIONS_PHONE: languageFile[localStorage.getItem("language")]["13132"],
				ACTIONS_WEBSITE:
					languageFile[localStorage.getItem("language")]["14523"],
				dayOfWeek: "dayOfWeek",
				value: "value",
			};
			let weekdaysMap = {
				Sun: languageFile[localStorage.getItem("language")]["20071"],
				Mon: languageFile[localStorage.getItem("language")]["20011"],
				Tue: languageFile[localStorage.getItem("language")]["20021"],
				Wed: languageFile[localStorage.getItem("language")]["20031"],
				Thu: languageFile[localStorage.getItem("language")]["20041"],
				Fri: languageFile[localStorage.getItem("language")]["20051"],
				Sat: languageFile[localStorage.getItem("language")]["20061"],
			};
			if (response.histogram.dayOfWeekHistogram) {
				var data = response.histogram.dayOfWeekHistogram
					.sort((a, b) => a.value - b.value)
					.map(function (item, index) {
						var singleItem = {};
						for (var i in item) {
							var value = item[i];
							if (i === "dayOfWeek") {
								value = weekdaysMap[value];
							}
							singleItem[hashMap[i]] = value;
						}
						return singleItem;
					});
				this.setState({ dateWiseHistoData: data });
			} else {
				this.setState({ dateWiseHistoData: [] });
			}
		} else {
			this.setState({ dateWiseHistoData: [] });
		}
	};
	getLocationInsight = () => {
		let response = GetLocationInsightMetricCountStore.getResponse();
		var hashMap = {
			VIEWS_SEARCH: "Search",
			VIEWS_MAPS: "Maps",
			BUSINESS_IMPRESSIONS_DESKTOP_MAPS: "Maps - Desktop",
			BUSINESS_IMPRESSIONS_MOBILE_MAPS: "Maps - Mobile",
			BUSINESS_IMPRESSIONS_MOBILE_SEARCH: "Search - Mobile",
			BUSINESS_IMPRESSIONS_DESKTOP_SEARCH: "Search - Desktop",
		};

		var data = modifyPieChartData(response, hashMap);
		if (data) {
			this.setState({ viewsPiedata: data });
		} else {
			this.setState({ viewsPiedata: {} });
		}
	};
	getStackedAreaData = () => {
		let response = GetStackedAreaChartStore.getResponse();
		if (response.status == 200) {
			this.setState({ customerViewData: response.histogram });
		} else {
			this.setState({ customerViewData: [] });
		}
	};
	getPerformanceOverview = () => {
		const response = GetPerformanceOverviewStore.getResponse();
		if (response.status == 200) {
			this.setState({ metricData: response });
		} else {
			this.setState({ metricData: [] });
		}
	};
	LocalHistogram() {
		var localhistogram = LocalHistogramStore.getResponse();
		this.setState({
			LocalHistoStackLabel: localhistogram.metricCount,
		});
	}

	onDatewiseActionCount() {
		var hashMap = {
			ACTIONS_DRIVING_DIRECTIONS:
				languageFile[localStorage.getItem("language")]["10792"],
			ACTIONS_PHONE: languageFile[localStorage.getItem("language")]["13132"],
			ACTIONS_WEBSITE: languageFile[localStorage.getItem("language")]["14523"],
			dayOfWeek: "dayOfWeek",
			value: "value",
		};
		var weekdaysMap = {
			Sun: languageFile[localStorage.getItem("language")]["20071"],
			Mon: languageFile[localStorage.getItem("language")]["20011"],
			Tue: languageFile[localStorage.getItem("language")]["20021"],
			Wed: languageFile[localStorage.getItem("language")]["20031"],
			Thu: languageFile[localStorage.getItem("language")]["20041"],
			Fri: languageFile[localStorage.getItem("language")]["20051"],
			Sat: languageFile[localStorage.getItem("language")]["20061"],
		};
		if (DatewiseInsightHistoStore.getResponse().histogram) {
			var data = DatewiseInsightHistoStore.getResponse()
				.histogram.dayOfWeekHistogram.sort((a, b) => a.value - b.value)
				.map(function (item, index) {
					var singleItem = {};
					for (var i in item) {
						var value = item[i];
						if (i === "dayOfWeek") {
							value = weekdaysMap[value];
						}
						singleItem[hashMap[i]] = value;
					}
					return singleItem;
				});
			this.setState({
				DatewiseInsightData: data,
			});
		}
	}
	onFetchStatus() {
		var statusData = GetDataFetchStatusStore.getResponse();
		var profileFetching = false;
		for (var account in statusData) {
			if (
				statusData[account].status !== "COMPLETED" &&
				statusData.status !== 404
			) {
				profileFetching = true;
			}
		}
		if (profileFetching) {
			var fetchingStatusData = [];
			if (
				GetDataFetchStatusStore.getResponse()[0].status === "FETCHING_LOCATIONS"
			) {
				fetchingStatusData = GetDataFetchStatusStore.getResponse()[0];
				this.setState({
					showInitalizingFetchers: false,
					fetchingStatusData: fetchingStatusData,
					showFetchingLocations: true,
					showFetchingStatus: false,
					loading: false,
				});
			} else if (
				GetDataFetchStatusStore.getResponse()[0].status === "FETCHING"
			) {
				fetchingStatusData = GetDataFetchStatusStore.getResponse()[0];
				this.setState({
					showInitalizingFetchers: true,
					fetchingStatusData: fetchingStatusData,
					showFetchingLocations: true,
					showFetchingStatus: false,
					loading: false,
				});
			} else {
				fetchingStatusData = GetDataFetchStatusStore.getResponse().map(
					function (item, index) {
						return {
							accountName: item.accountName,
							status: item.status,
							percentageFetched: Math.round(
								this.findFetchStatus(
									item.locationsProcessed,
									item.locationsFetched,
								),
							),
						};
					},
					this,
				);
				this.setState({
					showInitalizingFetchers: false,
					fetchingStatusData: fetchingStatusData,
					dataRetreivalStatus: "FETCHING_REVIEWS_INSIGHTS",
					showFetchingLocations: false,
					showFetchingStatus: true,
				});
			}
			} else {
			this.setState({
				showFetchingStatus: false,
			});
		}
	}
	findFetchStatus(locationsProcessed, totalLocations) {
		return (locationsProcessed / totalLocations) * 100;
	}
	onStatusResponse() {
		var statusData = GetDataStatusStore.getResponse().accountFetchStatuses;
		if (
			GetDataStatusStore.getResponse().status === "NO_ACCOUNTS_AUTHORIZED" &&
			GetDataStatusStore.getResponse().status === "NO_ACCOUNTS_ACTIVATED"
		) {
			this.setState({
				dataRetreivalStatus: "NO_ACCOUNTS_AUTHORIZED",
				loading: false,
			});
		} else if (GetDataStatusStore.getResponse().dataAvailability === false) {
			var profileLocationFetching;
			for (var account in statusData) {
				if (statusData[account].status === "NO_ACCOUNTS_AUTHORIZED") {
					this.setState({
						dataRetreivalStatus: "NO_ACCOUNTS_AUTHORIZED",
						loading: false,
					});
					break;
				} else if (statusData[account].status === "NO_ACCOUNTS_ACTIVATED") {
					this.setState({
						dataRetreivalStatus: "NO_ACCOUNTS_ACTIVATED",
						loading: false,
					});
					break;
				}
				if (statusData[account].status === "FETCHING_LOCATIONS") {
					profileLocationFetching = "LocationFetching";
					break;
				} else if (statusData[account].status === "FETCHING") {
					profileLocationFetching = "Fetching";
				} else if (statusData[account] === "QUEUE") {
					profileLocationFetching = "Queue";
				}
			}
			if (profileLocationFetching === "LocationFetching") {
				// GetDataFetchStatusAction.getStatus( localStorage.getItem('profileId') );
				this.setState({
					dataRetreivalStatus: "FETCHING_LOCATIONS_NO_DATA",
					loading: false,
				});
			} else if (profileLocationFetching === "Fetching") {
				this.setState({
					dataRetreivalStatus: "FETCHING_NO_DATA",
					loading: false,
				});
			} else {
				this.setState({
					dataRetreivalStatus: "QUEUE",
					loading: false,
				});
			}
		} else {
			var accountsFetching = false;
			if (
				GetDataStatusStore.getResponse().status === "NO_ACCOUNTS_AUTHORIZED" ||
				GetDataStatusStore.getResponse().status === "NO_ACCOUNTS_ACTIVATED"
			) {
				this.props.history.push("/settings/integrations");
			}
			for (var account in statusData) {
				if (statusData[account].status !== "COMPLETED") {
					accountsFetching = true;
				}
			}
			if (accountsFetching) {
				// GetDataFetchStatusAction.getStatus( localStorage.getItem('profileId') );
			} else {
				this.setState({
					showFetchingStatus: false,
				});
			}

			var profileId = localStorage.getItem("profileId");
			GetHistogramAction.changeProfile(profileId);
			DatewiseInsightHistoAction.changeProfile(profileId);
			GetSuggestionsAction.getSuggestions({}, profileId);
			GetLocationsStatesAction.changeProfile(profileId);
			GetLocationInsightAction.changeProfile(profileId);
			StackedBarChartAction.changeProfile(profileId);
			StackedAreaChartAction.changeProfile(profileId);
			StackedAreaChartCopyAction.changeProfile(profileId);
			LocalHistogramAction.changeProfile(profileId);
			InsightGroupBarchartAction.loadData();
			InsightGroupBarchartAction.loadDataCustomer();
			ActionsTypeCountAction.changeProfile(profileId);
			ViewsTypeCountAction.changeProfile(profileId);
			QueriesTypeCountAction.changeProfile(profileId);
			this.setState({
				dataRetreivalStatus: GetDataStatusStore.getResponse().status,
			});
		}
	}
	onProfileChange() {
		this.setState({
			loading: true,
		});
		GetDataStatusAction.getStatus(localStorage.getItem("profileId"));
	}
	onProfilesResponse() {
		intervalFunction = setInterval(function () {
			var callDataStatus = false;
			for (var i in GetDataStatusStore.getResponse().accountFetchStatuses) {
				if (
					GetDataStatusStore.getResponse().accountFetchStatuses[i].status !==
					"COMPLETED"
				) {
					callDataStatus = true;
					break;
				}
			}
			if (callDataStatus) {
				GetDataStatusAction.getStatus(localStorage.getItem("profileId"));
			}
		}, 15000);
		GetDataStatusAction.getStatus(localStorage.getItem("profileId"));
	}
	onLoadChange() {
		this.setState({
			graphLoading: true,
		});
	}
	modifyPieChartData(data, hashMap) {
		var pieChartData = [];
		for (var key in data) {
			pieChartData.push({ name: hashMap[key], value: data[key] });
		}
		return pieChartData;
	}
	onPhotosCountResponse() {
		var hashMap = {
			PHOTOS_COUNT_MERCHANT: "Photo Count",
			PHOTOS_VIEWS_MERCHANT: "Photo Views",
			date: "name",
		};
		var data = this.modifyPieChartData(
			PhotosTypeCountStore.getResponse(),
			hashMap,
		);
		this.setState({
			photosPiedata: data,
			photosLoading: false,
		});
	}
	onPhotosCountResponseCustomer() {
		var hashMap = {
			date: "name",
			PHOTOS_COUNT_CUSTOMERS: "Photo Count Customer",
			PHOTOS_VIEWS_CUSTOMERS: "Photo Views Customer",
		};
		var datas = this.modifyPieChartData(
			PhotosTypeCountCustomerStore.getResponse(),
			hashMap,
		);
		this.setState({
			photosPiedataCustomer: datas,
			photosLoading: false,
		});
	}
	onActionsCountResponse() {
		var hashMap = {
			ACTIONS_DRIVING_DIRECTIONS: "Driving Directions",
			ACTIONS_PHONE: "Phone",
			ACTIONS_WEBSITE: "Website",
			date: "date",
		};
		var data = this.modifyPieChartData(
			ActionsTypeCountStore.getResponse(),
			hashMap,
		);
		this.setState({
			actionsPieData: data,
			actionsLoading: false,
		});
	}
	onViewsCountResponse() {
		var hashMap = {
			VIEWS_SEARCH: "Search",
			VIEWS_MAPS: "Maps",
			BUSINESS_IMPRESSIONS_DESKTOP_MAPS: "Maps - Desktop",
			BUSINESS_IMPRESSIONS_MOBILE_MAPS: "Maps - Mobile",
			BUSINESS_IMPRESSIONS_MOBILE_SEARCH: "Search - Mobile",
			BUSINESS_IMPRESSIONS_DESKTOP_SEARCH: "Search - Desktop",
			date: "date",
		};
		var data = this.modifyPieChartData(
			ViewsTypeCountStore.getResponse(),
			hashMap,
		);
		this.setState({
			viewsPiedata: data,
			viewsLoading: false,
		});
	}
	onQueriesCountResponse() {
		var hashMap = {
			QUERIES_DIRECT: "Direct Queries",
			QUERIES_INDIRECT: "Indirect Queries",
			QUERIES_CHAIN: "Brand",
			date: "date",
		};
		var data = this.modifyPieChartData(
			QueriesTypeCountStore.getResponse(),
			hashMap,
		);
		this.setState({
			queriesPiedata: data,
			queriesLoading: false,
		});
	}
	onInsightsResponse() {
		var insightsData = GetLocationInsightStore.getResponse();
		this.setState({
			searchesCount: insightsData.searchesCount,
			viewsCount: insightsData.viewsCount,
			actionsCount: insightsData.actionsCount,
			searchesToViews: insightsData.searchesToViews,
			viewsToActions: insightsData.viewsToActions,
		});
	}
	onLocationStates() {
		this.setState({
			publishedLocations: GetLocationsStatesStore.getResponse().published,
			verifiedLocations: GetLocationsStatesStore.getResponse().unverified,
			openInfo: GetLocationsStatesStore.getResponse().openInfo,
		});
	}
	
	dateFormatter(data) {
		var modifiedData = data.map(function (item) {
			for (var i in item) {
				if (i === "date") {
					item[i] = moment(item[i]).format("ll");
				} else {
					if (item[i] === 0) {
						item[i] = null;
					}
				}
			}
		});
		return modifiedData;
	}
	onGraphResponse() {
		if (GetHistogramStore.getResponse().histogram) {
			var data = this.dateFormatter(GetHistogramStore.getResponse().histogram);
		}
		let avg = isNaN(
			Math.round(GetHistogramStore.getResponse().totalAverage * 10) / 10,
		)
			? "-"
			: Math.round(GetHistogramStore.getResponse().totalAverage * 10) / 10;
		this.setState({
			loading: false,
			data: GetHistogramStore.getResponse().histogram,
			avg: avg,
			totalCount: GetHistogramStore.getResponse().totalCount,
		});
	}
	findPercent(label, data) {
		if (data) {
			if (data.length === 0) {
				return 0;
			} else {
				var sum = 0;
				for (var i in data) {
					sum = sum + data[i].value;
				}
				var percent;
				for (var i in data) {
					if (data[i].name === label) {
						percent = (data[i].value / sum) * 100;
					}
				}
				return Math.round(percent * 100) / 100 + "%";
			}
		}
	}
	findNumShortForm(label, data) {
		if (data) {
			var value = _.find(data, function (item) {
				return item.name === label;
			}).value;
			if (value > 999) {
				var suffixes = ["", "k", "M", "B", "T"];
				var suffixNum = Math.floor(("" + value).length / 3);
				var shortValue = parseFloat(
					(suffixNum != 0
						? value / Math.pow(1000, suffixNum)
						: value
					).toPrecision(2),
				);
				if (shortValue % 1 != 0) {
					var shortNum = shortValue.toFixed(1);
				}
				return shortValue + suffixes[suffixNum];
			} else {
				return value;
			}
		} else {
			return 0;
		}
	}
	findLabelValue(data, label) {
		if (!_.isEmpty(data)) {
			var value = _.find(data, function (item) {
				return item.name === label;
			}).value;
			return value.toLocaleString();
		} else {
			return 0;
		}
	}
	getData(filter, userFilters) {
		let spliceData = "";
		let returnData = "";
		spliceData = userFilters.filter(function (item, index) {
			return item.split("=")[0] === filter;
		});
		returnData = spliceData.length ? spliceData[0].split("=") : "";
		if (returnData && returnData[1]) {
			return returnData[1].replace("%26", "&");
		} else {
			return "";
		}
	}
	ChangeFormateDate(oldDate, divider) {
		return oldDate.toString().split("-").reverse().join(divider);
	}
	ChangeDivider(date) {
		return date.toString().split("-").join(".");
	}
	generateReportHeader() {
		let reportHeader = "",
			headerJoin = "",
			locationName = "",
			fromDate = "",
			toDate = "",
			domain = "";
		let userFilters = this.props.match.params.query.split("&");
		locationName = this.getData("locationName", userFilters);
		fromDate = this.getData("fromDate", userFilters);
		toDate = this.getData("toDate", userFilters);
		domain = this.getData("domain", userFilters);
		fromDate = GetDomainDetailsStore.getResponse().reportDateChange
			? this.ChangeFormateDate(fromDate, ".")
			: this.ChangeDivider(fromDate);
		toDate = GetDomainDetailsStore.getResponse().reportDateChange
			? this.ChangeFormateDate(toDate, ".")
			: this.ChangeDivider(toDate);

		if (locationName) {
			headerJoin = fromDate + " - " + toDate;
			reportHeader = (
				<div className="report-header">
					<span className="header-location">{locationName}</span>
					<span className="report-filter-capitalize">{headerJoin}</span>
				</div>
			);
		}
		return reportHeader;
	}
	generateReportFilters() {
		let reportFilters = [],
			locationName = "",
			domain = "";
		let userFilters = this.props.match.params.query.split("&");
		locationName = this.getData("locationName", userFilters);
		domain = this.getData("domain", userFilters);
		let dateFilters = userFilters.filter(function (item, index) {
			return (
				item.split("=")[0] === "fromDate" || item.split("=")[0] === "toDate"
			);
		});
		let starRatingFilter = userFilters.filter(function (item, index) {
			return (
				item.split("=")[0] === "starType" || item.split("=")[0] === "starValue"
			);
		});
		let remainingFilters = userFilters.filter(function (item, index) {
			return (
				item.split("=")[0] !== "fromDate" &&
				item.split("=")[0] !== "toDate" &&
				item.split("=")[0] !== "starType" &&
				item.split("=")[0] !== "starValue"
			);
		});
		function rotate(array, times) {
			while (times--) {
				var temp = array.shift();
				array.push(temp);
			}
		}
		rotate(remainingFilters, 3);
		remainingFilters.map((item, index) => {
			let filter = item.split("=");
			if (fieldsMap.hasOwnProperty(filter[0]) && filter[1] && filter[1]) {
				reportFilters.push(
					<div style={{ display: "inline-block", marginRight: 5 }}>
						<span className="report-filter-capitalize">
							{fieldsMap[filter[0]]}:{" "}
						</span>
						<span className="report-filter-capitalize">
							{
								
								decodeURIComponent(filter[1]) +
									(index == this.props.match.params.query.split("&").length - 2
										? ""
										: ",")
							}
						</span>
					</div>,
				);
			}
		});
		if (!locationName) {
			dateFilters.map((item, index) => {
				let filter = item.split("=");
				if (fieldsMap.hasOwnProperty(filter[0]) && filter[1]) {
					reportFilters.push(
						<div style={{ display: "inline-block", marginRight: 5 }}>
							<span className="report-filter-capitalize">
								{fieldsMap[filter[0]]}:{" "}
							</span>
							<span className="report-filter-capitalize">
								{(filter[0] == "starType"
									? fieldsMap[filter[1]]
									: GetDomainDetailsStore.getResponse().reportDateChange
									? this.ChangeFormateDate(filter[1], "-")
									: filter[1]) +
									(index == this.props.match.params.query.split("&").length - 2
										? ""
										: ",")}
							</span>
						</div>,
					);
				}
			});
		}
		if (starRatingFilter.length == 2) {
			reportFilters.push(
				<div style={{ display: "inline-block", marginRight: 5 }}>
					<span className="report-filter-capitalize">
						{fieldsMap[starRatingFilter[0].split("=")[0]]}:{" "}
					</span>
					<span className="report-filter-capitalize">{`${
						fieldsMap[starRatingFilter[0].split("=")[1]]
					} ${starRatingFilter[1].split("=")[1]}`}</span>
				</div>,
			);
		}
		return reportFilters;
	}

	getGranularityLabel = () => {
		let userFilters = this.props.match.params.query.split("&");
		const filterObj = {};

	userFilters.forEach((item) => {
			const [key, value] = item.split("=");
			if (key) {
				filterObj[key] = decodeURIComponent(value || "");
			}
		});

		const granularity = (filterObj.granularity || "").toLowerCase();

		switch (granularity) {
			case "weekly":
				return "Weekly";
			case "monthly":
				return "Monthly";
			case "daily":
				return "Daily";
			default:
				return "";
		}
	};
	getProfile = () => {
		let userFilters = this.props.match.params.query.split("&");
		const filterObj = {};

		userFilters.forEach((item) => {
			const [key, value] = item.split("=");
			if (key) {
				filterObj[key] = decodeURIComponent(value || "");
			}
		});

		return filterObj.profileName || "";
	};
	getGranularityRange = () => {
		let userFilters = this.props.match.params.query.split("&");
		let day = "";
		const filterObj = {};
		userFilters.forEach((item) => {
			const [key, value] = item.split("=");
			filterObj[key] = value;
		});

		let granularity = filterObj.granularity || "";
		switch (granularity.toLowerCase()) {
			case "weekly":
				day = "Weekly";
				break;
			case "monthly":
				day = "Monthly";
				break;
			case "daily":
				day = "Daily";
				break;
			default:
				day = "";
		}
		if (!granularity) {
			return `Chart Granularity : ${day}`;
		} else {
			return `Chart Granularity : ${day}`;
		}
	};
	getGranularityTime = () => {
		let userFilters = this.props.match.params.query.split("&");
		const filterObj = {};
		userFilters.forEach((item) => {
			const [key, value] = item.split("=");
			filterObj[key] = value;
		});

		let fromDate = filterObj.fromDate;
		let toDate = filterObj.toDate;

		fromDate = GetDomainDetailsStore.getResponse().reportDateChange
			? this.ChangeFormateDate(fromDate, ".")
			: this.ChangeDivider(fromDate);

		toDate = GetDomainDetailsStore.getResponse().reportDateChange
			? this.ChangeFormateDate(toDate, ".")
			: this.ChangeDivider(toDate);

		
		return `Range: ${fromDate} - ${toDate}`;
	};
	getFilters = () => {
		const userFilters = this.props.match.params.query.split("&");
		const filtersToShow = [];

		const queryMap = {};
		userFilters.forEach((item) => {
			const [k, v] = item.split("=");
			queryMap[k] = decodeURIComponent(v);
		});

		userFilters.forEach((item) => {
			let [key, rawValue] = item.split("=");
			let value = decodeURIComponent(rawValue);

			if (!value || !fieldsMap[key]) return;

			// ⭐ Combine starType + starValue
			if (key === "starType") {
				const starValue = queryMap["starValue"]; // e.g. "3"

				// If no starValue skip showing starType
				if (!starValue) return;

				// Build final combined value
				value = `${fieldsMap[value]} ${starValue}`; // "LT 3"
			}

			// ⭐ Skip starValue as we already used it
			if (key === "starValue") return;

			// Style mapping
			const styleForKey = tagStyles[key] || {
				color: "#595959",
				background: "#fafafa",
				borderColor: "#d9d9d9",
			};

			filtersToShow.push(
				<span
					key={key + value}
					style={{
						display: "inline-block",
						padding: "4px 8px",
						borderRadius: "14px",
						marginRight: "3px",
						marginBottom: "3px",
						fontSize: "12px",
						border: `1px solid ${styleForKey.borderColor}`,
						background: styleForKey.background,
						color: styleForKey.color,
					}}>
					<b>{fieldsMap[key]}:</b>{" "}
					<span style={{ color: styleForKey.color }}>{value}</span>
				</span>,
			);
		});

		if (filtersToShow.length === 0) return null;

		return (
			<div
				style={{
					display: "flex",
					flexWrap: "wrap",
					alignItems: "center",
					gap: "10px",
				}}>
				<b>Filters:</b> {filtersToShow}
			</div>
		);
	};

	render() {
		var url = require("url");
		var adr = window.location.href;
		var parseUrlName = url.parse(adr, true);
		var urlName = parseUrlName.host;

		var qurysum,
			conversionSum,
			dierctCount,
			indirectCount,
			action_phone,
			action_website,
			action_drivingdirection,
			desktopMapsCount = 0,
			desktopSearchCount = 0,
			mobileMapsCount = 0,
			mobileSearchCount = 0,
			viewMapsCount = 0,
			viewSearchCount = 0,
			chainCount;
		_.map(
			this.state.LocalHistoStackLabel && this.state.LocalHistoStackLabel,
			function (item, key) {
				if (item.hasOwnProperty("QUERIES_DIRECT")) {
					dierctCount = item.QUERIES_DIRECT.sum;
				}
				if (item.hasOwnProperty("QUERIES_INDIRECT")) {
					indirectCount = item.QUERIES_INDIRECT.sum;
				}
				if (item.hasOwnProperty("QUERIES_CHAIN")) {
					chainCount = item.QUERIES_CHAIN.sum;
				}
				if (item.hasOwnProperty("ACTIONS_DRIVING_DIRECTIONS")) {
					action_drivingdirection = item.ACTIONS_DRIVING_DIRECTIONS.sum;
				}
				if (item.hasOwnProperty("ACTIONS_PHONE")) {
					action_phone = item.ACTIONS_PHONE.sum;
				}
				if (item.hasOwnProperty("ACTIONS_WEBSITE")) {
					action_website = item.ACTIONS_WEBSITE.sum;
				}
				if (item.hasOwnProperty("BUSINESS_IMPRESSIONS_DESKTOP_MAPS")) {
					desktopMapsCount = item.BUSINESS_IMPRESSIONS_DESKTOP_MAPS.sum;
				}
				if (item.hasOwnProperty("BUSINESS_IMPRESSIONS_DESKTOP_SEARCH")) {
					desktopSearchCount = item.BUSINESS_IMPRESSIONS_DESKTOP_SEARCH.sum;
				}
				if (item.hasOwnProperty("BUSINESS_IMPRESSIONS_MOBILE_MAPS")) {
					mobileMapsCount = item.BUSINESS_IMPRESSIONS_MOBILE_MAPS.sum;
				}
				if (item.hasOwnProperty("BUSINESS_IMPRESSIONS_MOBILE_SEARCH")) {
					mobileSearchCount = item.BUSINESS_IMPRESSIONS_MOBILE_SEARCH.sum;
				}
				if (item.hasOwnProperty("VIEWS_MAPS")) {
					viewMapsCount = item.VIEWS_MAPS.sum;
				}
				if (item.hasOwnProperty("VIEWS_SEARCH")) {
					viewSearchCount = item.VIEWS_SEARCH.sum;
				}
			},
		);
		qurysum = dierctCount + indirectCount + chainCount;
		conversionSum =
			desktopMapsCount +
			desktopSearchCount +
			mobileMapsCount +
			mobileSearchCount +
			viewMapsCount +
			viewSearchCount;
		if (this.state.loading) {
			return (
				<div className="loader-main">
					<div className="loader"></div>
				</div>
			);
		}
		var emptyStates = [
			"QUEUE",
			"NO_ACCOUNTS_AUTHORIZED",
			"NO_ACCOUNTS_ACTIVATED",
			"FETCHING_NO_DATA",
			"FETCHING_LOCATIONS_NO_DATA",
		];

		if (emptyStates.indexOf(this.state.dataRetreivalStatus) != -1) {
			return (
				<EmptyStates
					status={this.state.dataRetreivalStatus}
					fetchingStatusData={this.state.fetchingStatusData}
				/>
			);
		}

		if (this.state.data && this.state.data.length === 0) {
			var noDataFlag = true;
		}

		const getCount = (field) => {
			let directCount = 0,
				indirectCount = 0,
				chainCount = 0,
				action_phone = 0,
				action_website = 0,
				action_drivingdirection = 0,
				desktopMapsCount = 0,
				desktopSearchCount = 0,
				mobileMapsCount = 0,
				mobileSearchCount = 0,
				viewMapsCount = 0,
				viewSearchCount = 0,
				conversionSum = 0;

			// Check if localHistoMetric is defined and iterate
			if (this.state.localHistoMetric) {
				_.forEach(this.state.localHistoMetric, (item) => {
					if (item.QUERIES_DIRECT) directCount += item.QUERIES_DIRECT.sum || 0;
					if (item.QUERIES_INDIRECT)
						indirectCount += item.QUERIES_INDIRECT.sum || 0;
					if (item.QUERIES_CHAIN) chainCount += item.QUERIES_CHAIN.sum || 0;
					if (item.ACTIONS_DRIVING_DIRECTIONS)
						action_drivingdirection += item.ACTIONS_DRIVING_DIRECTIONS.sum || 0;
					if (item.ACTIONS_PHONE) action_phone += item.ACTIONS_PHONE.sum || 0;
					if (item.ACTIONS_WEBSITE)
						action_website += item.ACTIONS_WEBSITE.sum || 0;
					if (item.BUSINESS_IMPRESSIONS_DESKTOP_MAPS)
						desktopMapsCount += item.BUSINESS_IMPRESSIONS_DESKTOP_MAPS.sum || 0;
					if (item.BUSINESS_IMPRESSIONS_DESKTOP_SEARCH)
						desktopSearchCount +=
							item.BUSINESS_IMPRESSIONS_DESKTOP_SEARCH.sum || 0;
					if (item.BUSINESS_IMPRESSIONS_MOBILE_MAPS)
						mobileMapsCount += item.BUSINESS_IMPRESSIONS_MOBILE_MAPS.sum || 0;
					if (item.BUSINESS_IMPRESSIONS_MOBILE_SEARCH)
						mobileSearchCount +=
							item.BUSINESS_IMPRESSIONS_MOBILE_SEARCH.sum || 0;
					if (item.VIEWS_MAPS) viewMapsCount += item.VIEWS_MAPS.sum || 0;
					if (item.VIEWS_SEARCH) viewSearchCount += item.VIEWS_SEARCH.sum || 0;
				});
			}

			// Calculate total conversions
			conversionSum =
				desktopMapsCount +
				desktopSearchCount +
				mobileMapsCount +
				mobileSearchCount +
				viewMapsCount +
				viewSearchCount;
			// Return the requested field percentage
			if (field === "drivingdirection") {
				let data = this.state.localHistoData
					? _.round((action_drivingdirection * 100) / conversionSum, 2) + "%"
					: "-";
				return data;
			}
			if (field === "phone") {
				return this.state.localHistoData
					? `${_.round((action_phone * 100) / conversionSum, 2)}%`
					: "-";
			}
			if (field === "website") {
				return this.state.localHistoData
					? `${_.round((action_website * 100) / conversionSum, 2)}%`
					: "-";
			}

			return "-"; // Default case if field doesn't match
		};
		return (
			<div className="dashboard-outer">
				<div className="print-header">
					<div className="print-logo">
						<img
							src={
								config.logoBaseUrl +
								"/" +
								localStorage.getItem("profileId") +
								"/logo.png?time=" +
								Date.now()
							}
							onError={(e) =>
								(e.target.src = `/images/${urlName}/logo-text.png`)
							}
						/>
					</div>
				</div>
				<div className={styles.dashboard}>
					{/* <div className="report-options">
						{this.generateReportHeader()}
						{this.generateReportFilters()}
					</div> */}

					{/* <div className="row">
						<div className="col-sm-4 col-md-4 col-lg-4">
							<TopLocationsWidget title="Countries" type="Country" data={this.state.topCountries} />
						</div>
						<div className="col-sm-4 col-md-4 col-lg-4">
							<TopLocationsWidget title="Areas" type="Area" data={this.state.topAreas} />
						</div>
						<div className="col-sm-4 col-md-4 col-lg-4">
							<TopLocationsWidget title="Localities" type="Locality" data={this.state.topLocalities} />
						</div>
					</div> */}
					<div className={styles.header}>
						<h2 className={styles.title}>
							{languageFile[localStorage.getItem("language")]["30890"]} (
							{this.getGranularityLabel()})
						</h2>
						<span className={styles.profile}>Profile: {this.getProfile()}</span>
						<span className={styles.granularity}>
							<span>{this.getGranularityTime()}</span>
							<span>{this.getGranularityRange()}</span>
							<span>{"Report :" + " " + this.jobType}</span>
							<span>{this.getFilters()}</span>
						</span>
					</div>
					<div className={styles.dashboard}>
						<div className={styles.metricBlock}>
							<MetricCard
								loader={false}
								title={METRIC_CARD_CONSTANTS.TOTAL_VIEWS}
								info={TOOLTIP_CONSTANTS.TOTAL_VIEWS_INFO}
								value={
									this.state.metricData &&
									this.state.metricData.views &&
									this.state.metricData.views.totalViews
										? this.state.metricData.views.totalViews.toLocaleString()
										: 0
								}
								additionalInfo={
									(this.state.metricData &&
										this.state.metricData.views &&
										this.state.metricData.views.avgLocation &&
										this.state.metricData.views.avgLocation) ||
									0
								}
								changePercent={
									this.state.metricData &&
									this.state.metricData.views &&
									this.state.metricData.views.trendPercent
										? this.state.metricData.views.trendPercent
										: 0
								}
								dateInterval={""}
								width={"32%"}
							/>
							<MetricCard
								loader={false}
								title={METRIC_CARD_CONSTANTS.MAP_VIEWS}
								info={TOOLTIP_CONSTANTS.MAP_VIEWS_INFO}
								value={
									this.state.metricData &&
									this.state.metricData.mapViews &&
									this.state.metricData.mapViews.mapViews
										? this.state.metricData.mapViews.mapViews.toLocaleString()
										: 0
								}
								additionalInfo={
									(this.state.metricData &&
									this.state.metricData.mapViews &&
									this.state.metricData.mapViews.mapPercent &&
									this.state.metricData.mapViews.mapPercent
										.BUSINESS_IMPRESSIONS_DESKTOP_MAPS
										? this.state.metricData.mapViews.mapPercent.BUSINESS_IMPRESSIONS_DESKTOP_MAPS.toFixed(
												0,
										  ) + "%"
										: 0) +
									", " +
									(this.state.metricData &&
									this.state.metricData.mapViews &&
									this.state.metricData.mapViews.mapPercent &&
									this.state.metricData.mapViews.mapPercent
										.BUSINESS_IMPRESSIONS_MOBILE_MAPS
										? this.state.metricData.mapViews.mapPercent.BUSINESS_IMPRESSIONS_MOBILE_MAPS.toFixed(
												0,
										  ) + "%"
										: 0 + "%")
								}
								changePercent={
									this.state.metricData &&
									this.state.metricData.mapViews &&
									this.state.metricData.mapViews.trendPercent
										? this.state.metricData.mapViews.trendPercent
										: 0
								}
								dateInterval={""}
								width={"32%"}
							/>
							<MetricCard
								loader={false}
								title={METRIC_CARD_CONSTANTS.SEARCH_VIEWS}
								info={TOOLTIP_CONSTANTS.SEARCH_VIEWS_INFO}
								value={
									this.state.metricData &&
									this.state.metricData.searchViews &&
									this.state.metricData.searchViews.searchViews
										? this.state.metricData.searchViews.searchViews.toLocaleString()
										: 0
								}
								additionalInfo={
									(this.state.metricData &&
									this.state.metricData.searchViews &&
									this.state.metricData.searchViews.searchPercent &&
									this.state.metricData.searchViews.searchPercent
										.BUSINESS_IMPRESSIONS_DESKTOP_SEARCH
										? this.state.metricData.searchViews.searchPercent.BUSINESS_IMPRESSIONS_DESKTOP_SEARCH.toFixed(
												0,
										  ) + "%"
										: 0 + "%") +
									", " +
									(this.state.metricData &&
									this.state.metricData.searchViews &&
									this.state.metricData.searchViews.searchPercent &&
									this.state.metricData.searchViews.searchPercent
										.BUSINESS_IMPRESSIONS_MOBILE_SEARCH
										? this.state.metricData.searchViews.searchPercent.BUSINESS_IMPRESSIONS_MOBILE_SEARCH.toFixed(
												0,
										  ) + "%"
										: 0 + "%")
								}
								changePercent={
									this.state.metricData &&
									this.state.metricData.searchViews &&
									this.state.metricData.searchViews.trendPercent
										? this.state.metricData.searchViews.trendPercent
										: 0
								}
								dateInterval={""}
								width={"32%"}
							/>
							<MetricCard
								loader={false}
								title={METRIC_CARD_CONSTANTS.ACTIONS}
								info={TOOLTIP_CONSTANTS.ACTIONS_INFO}
								value={
									this.state.metricData &&
									this.state.metricData.totalActions &&
									this.state.metricData.totalActions.totalActions
										? this.state.metricData.totalActions.totalActions.toLocaleString()
										: 0
								}
								additionalInfo={
									(this.state.metricData &&
									this.state.metricData.totalActions &&
									this.state.metricData.totalActions.actionsPercent &&
									this.state.metricData.totalActions.actionsPercent
										.ACTIONS_DRIVING_DIRECTIONS
										? this.state.metricData.totalActions.actionsPercent.ACTIONS_DRIVING_DIRECTIONS.toFixed(
												0,
										  ) + "%"
										: 0 + "%") +
									", " +
									(this.state.metricData &&
									this.state.metricData.totalActions &&
									this.state.metricData.totalActions.actionsPercent &&
									this.state.metricData.totalActions.actionsPercent
										.ACTIONS_PHONE
										? this.state.metricData.totalActions.actionsPercent.ACTIONS_PHONE.toFixed(
												0,
										  ) + "%"
										: 0 + "%") +
									", " +
									(this.state.metricData &&
									this.state.metricData.totalActions &&
									this.state.metricData.totalActions.actionsPercent &&
									this.state.metricData.totalActions.actionsPercent
										.ACTIONS_WEBSITE
										? this.state.metricData.totalActions.actionsPercent.ACTIONS_WEBSITE.toFixed(
												0,
										  ) + "%"
										: 0 + "%")
								}
								changePercent={
									this.state.metricData &&
									this.state.metricData.mapViews &&
									this.state.metricData.mapViews.trendPercent
										? this.state.metricData.mapViews.trendPercent
										: 0
								}
								dateInterval={""}
								width={"32%"}
							/>
							<MetricCard
								loader={false}
								title={METRIC_CARD_CONSTANTS.CONV_RATE}
								info={TOOLTIP_CONSTANTS.CONVERSION_RATE_INFO}
								value={
									this.state.metricData &&
									this.state.metricData.conversionRate &&
									this.state.metricData.conversionRate.conversionRate
										? this.state.metricData.conversionRate.conversionRate.toFixed(
												2,
										  ) + "%"
										: "0%"
								}
								additionalInfo={
									(this.state.metricData &&
									this.state.metricData.conversionRate &&
									this.state.metricData.conversionRate.conversionRatePercent &&
									this.state.metricData.conversionRate.conversionRatePercent
										.ACTIONS_DRIVING_DIRECTIONS
										? this.state.metricData.conversionRate.conversionRatePercent.ACTIONS_DRIVING_DIRECTIONS.toFixed(
												1,
										  ) + "%"
										: 0 + "%") +
									", " +
									(this.state.metricData &&
									this.state.metricData.conversionRate &&
									this.state.metricData.conversionRate.conversionRatePercent &&
									this.state.metricData.conversionRate.conversionRatePercent
										.ACTIONS_PHONE
										? this.state.metricData.conversionRate.conversionRatePercent.ACTIONS_PHONE.toFixed(
												1,
										  ) + "%"
										: 0 + "%") +
									", " +
									(this.state.metricData &&
									this.state.metricData.conversionRate &&
									this.state.metricData.conversionRate.conversionRatePercent &&
									this.state.metricData.conversionRate.conversionRatePercent
										.ACTIONS_WEBSITE
										? this.state.metricData.conversionRate.conversionRatePercent.ACTIONS_WEBSITE.toFixed(
												1,
										  ) + "%"
										: 0 + "%")
								}
								changePercent={
									this.state.metricData &&
									this.state.metricData.conversionRate &&
									this.state.metricData.conversionRate.trendPercent
										? this.state.metricData.conversionRate.trendPercent
										: 0
								}
								dateInterval={""}
								width={"32%"}
							/>
						</div>

						<div className={styles.reviewsTable}>
							<LPOChartWrapper
								loader={false}
								label={languageFile[localStorage.getItem("language")]["30899"]}
								data={this.state.customerViewData}
								download={""}
								onDownloadClick={() => {}}
								chart={"customers"}
								desc={languageFile[localStorage.getItem("language")]["30900"]}
								mapMobileCount={findLabelValue(
									this.state.viewsPiedata,
									"Maps - Mobile",
								)}
								mapMobilePercent={findPercent(
									"Maps - Mobile",
									this.state.viewsPiedata,
								)}
								mapDesktopCount={findLabelValue(
									this.state.viewsPiedata,
									"Maps - Desktop",
								)}
								mapDesktopPercent={findPercent(
									"Maps - Desktop",
									this.state.viewsPiedata,
								)}
								searchMobileCount={findLabelValue(
									this.state.viewsPiedata,
									"Search - Mobile",
								)}
								searchMobilePercent={findPercent(
									"Search - Mobile",
									this.state.viewsPiedata,
								)}
								searchDesktopCount={findLabelValue(
									this.state.viewsPiedata,
									"Search - Desktop",
								)}
								searchDesktopPercent={findPercent(
									"Search - Desktop",
									this.state.viewsPiedata,
								)}>
								<StackedAreaChart data={this.state.customerViewData} />
							</LPOChartWrapper>
						</div>
						<div className={styles.pageBreak}></div>
						<br></br>
						<div
							className={styles.reviewsTable}
							style={{ marginTop: "50px" }}>
							<LPOChartWrapper
								loader={false}
								label={languageFile[localStorage.getItem("language")]["30901"]}
								data={this.state.customerActionData}
								download={false}
								// onDownloadClick={lineChartCsv}
								chart={"action"}
								desc={languageFile[localStorage.getItem("language")]["30902"]}
								mapMobileCount={findLabelValue(
									this.state.actionsPieData,
									"Driving Directions",
								)}
								mapMobilePercent={findPercent(
									"Driving Directions",
									this.state.actionsPieData,
								)}
								mapDesktopCount={findLabelValue(
									this.state.actionsPieData,
									"Phone",
								)}
								mapDesktopPercent={findPercent(
									"Phone",
									this.state.actionsPieData,
								)}
								searchMobileCount={findLabelValue(
									this.state.actionsPieData,
									"Website",
								)}
								searchMobilePercent={findPercent(
									"Website",
									this.state.actionsPieData,
								)}>
								<LineChartComponent data={this.state.customerActionData} />
							</LPOChartWrapper>
						</div>

						<div
							className={styles.graphBlock}
							style={{ marginTop: "20px" }}>
							<CommentsGraphWrapper
								data={this.state.dateWiseHistoData}
								loader={false}
								desc={""}
								total={this.state.dateWiseHistoData.length}
								label={languageFile[localStorage.getItem("language")]["10795"]}>
								<ComposedBarChart
									data={this.state.dateWiseHistoData}
									language={
										languageFile[localStorage.getItem("language")]["10792"]
									}
								/>
							</CommentsGraphWrapper>
							<CommentsGraphWrapper
								data={this.state.dateWiseHistoData}
								loader={false}
								desc={""}
								total={this.state.dateWiseHistoData.length}
								label={languageFile[localStorage.getItem("language")]["13135"]}>
								<ComposedBarChart
									data={this.state.dateWiseHistoData}
									language={
										languageFile[localStorage.getItem("language")]["13132"]
									}
								/>
							</CommentsGraphWrapper>
							<CommentsGraphWrapper
								data={this.state.dateWiseHistoData}
								loader={false}
								desc={""}
								total={this.state.dateWiseHistoData.length}
								label={languageFile[localStorage.getItem("language")]["14526"]}>
								<ComposedBarChart
									data={this.state.dateWiseHistoData}
									language={
										languageFile[localStorage.getItem("language")]["14523"]
									}
								/>
							</CommentsGraphWrapper>
						</div>
						<div className={styles.pageBreak}></div>
						<br></br>
						<div
							className={styles.reviewsTable}
							style={{ marginTop: "50px" }}>
							<LPOChartWrapper
								loader={false}
								label={languageFile[localStorage.getItem("language")]["2072"]}
								data={this.state.localHistoData}
								chart={"conversion"}
								download={false}
								mapMobileCount={getCount("drivingdirection")}
								mapDesktopCount={getCount("phone")}
								mapDesktopPercent={getCount("website")}
								desc={languageFile[localStorage.getItem("language")]["30903"]}>
								<LocalHistogramComponent data={this.state.localHistoData} />
							</LPOChartWrapper>
						</div>
					</div>
					<div className="nightmare-check-stacked-bar nightmare-check-stacked-area nightmare-check-stacked-line"></div>
				</div>
			</div>
		);
	}
}

export default DownloadPerformanceInsights;
